import { defineStore } from 'pinia'

import type { AssessmentResultsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useAssessmentResultsStore = defineStore('assessment-results', {
  state: (): AssessmentResultsStore => ({
    listById: {},
    resultById: {},
  }),
  actions,
  getters,
})
